import ArgonTypography from "components/ArgonTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import ArgonBox from "components/ArgonBox";
import Card from "@mui/material/Card";
import Footer from "examples/Footer";
import { Grid } from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";
import BasicDetails from "./tutorProfileTabs/BasicDetails";
import TeachingPreference from "./tutorProfileTabs/TeachingPreference";
import LocationPrefernce from "./tutorProfileTabs/LocationPrefernce";
import Payments from "./tutorProfileTabs/Payments";
import PersonalInformation from "./tutorProfileTabs/PersonalInformation";
import InterviewDetails from "./tutorProfileTabs/InterviewDetails";
import DemoAndClassAllocated from "./tutorProfileTabs/DemoAndClassAllocated";
import Profile from "./tutorProfileTabs/Profile";
import TutorStudentAttendance from "./tutorProfileTabs/TutorStudentAttendance";
import icon from "assets/theme/components/icon";
import TeachingExperience from "./tutorProfileTabs/TeachingExperience";
import IntroductionDetails from "./tutorProfileTabs/IntroductionDetails";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios, { baseURL } from "utils/api";
import { Chip } from "@mui/material";
import OnboardingProgressBar from "components/OnboardingProgressBar/OnboardingProgressBar";

function AddTutor() {
  const { id } = useParams();
  const [followUpStatus, setFollowUpStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tutorData, setTutorData] = useState(null);
  const [onboardingSteps, setOnboardingSteps] = useState([
    { label: "Teaching Preferences", completed: false },
    { label: "Profile Info", completed: false },
    { label: "Work Experience", completed: false },
    { label: "Video Intro", completed: false },
    { label: "Interview", completed: false },
  ]);

  // Fetch tutor data and onboarding status
  useEffect(() => {
    const fetchTutorData = async () => {
      try {
        // Fetch basic tutor data
        const tutorResponse = await axios.get(`${baseURL}/tutor/${id}`);
        console.log("Tutor API response:", tutorResponse.data);

        if (tutorResponse.data.success && tutorResponse.data.data) {
          setTutorData(tutorResponse.data.data);
        }

        // Fetch tutor onboarding status from dedicated API
        try {
          const statusResponse = await axios.get(`${baseURL}/tutor/status/${id}`);
          console.log("✅ Tutor Status API Full Response:", statusResponse.data);

          if (statusResponse.data.success && statusResponse.data.data) {
            const statusData = statusResponse.data.data;
            const completedSteps = statusData.completedSteps || {};

            
            // Update onboarding steps based on status API data
            const updatedSteps = [
              {
                label: "Teaching Preferences",
                completed: completedSteps.teachingPreferences === true,
              },
              { label: "Profile Info", completed: completedSteps.profileInformation === true },
              { label: "Work Experience", completed: completedSteps.workExperience === true },
              { label: "Video Intro", completed: completedSteps.videoIntroduction === true },
              { label: "Interview", completed: completedSteps.virtualInterview === true },
            ];

            console.log("✅ Updated Steps Array:", updatedSteps);
            setOnboardingSteps(updatedSteps);
          }
        } catch (statusError) {
          console.error("❌ Error fetching tutor status:", statusError);
          console.error("Status Error Details:", statusError.response?.data);
        }
      } catch (error) {
        console.error("❌ Error fetching tutor data:", error);
      }
    };

    if (id) {
      fetchTutorData();
    }
  }, [id]);

  // Fetch tutor CRM data for follow-up status
  useEffect(() => {
    const fetchTutorCRMData = async () => {
      try {
        const response = await axios.get(`${baseURL}/crm?tutorId=${id}`);
        console.log("CRM API response:", response.data);
        const crmEntries = response.data?.data?.crmEntries || [];
        if (crmEntries.length > 0 && crmEntries[0].followUpStatus) {
          setFollowUpStatus(crmEntries[0].followUpStatus);
        } else {
          setFollowUpStatus(null);
        }
      } catch (error) {
        console.error("Error fetching tutor CRM data:", error);
        setFollowUpStatus(null);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchTutorCRMData();
    }
  }, [id]);

  const tabsData = [
    {
      label: "Basic Details",
      icon: <i className="ri-user-line"></i>,
      status: "success",
      content: <BasicDetails />,
    },
    {
      label: "Introduction Details",
      icon: <i className="ri-video-line"></i>,
      status: "success",
      content: <IntroductionDetails />,
    },
    {
      label: "Interview Details",
      icon: <i className="ri-question-answer-line"></i>,
      status: "success",
      content: <InterviewDetails />,
    },
    {
      label: "Demo And Class allocated",
      icon: <i className="ri-calendar-check-line"></i>,
      status: "success",
      content: <DemoAndClassAllocated />,
    },
    {
      label: "Tutor-Student Attendance",
      icon: <i className="ri-clipboard-line"></i>,
      status: "success",
      content: <TutorStudentAttendance tutorId={id} />,
    },
    {
      label: "Payments",
      icon: <i className="ri-wallet-line"></i>,
      status: "success",
      content: <Payments />,
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox p={3}>
              <ArgonBox display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <ArgonTypography variant="h6">Tutor Profile</ArgonTypography>
                {!loading &&
                  (followUpStatus ? (
                    <Chip
                      label={`Current Status: ${followUpStatus}`}
                      color="primary"
                      variant="outlined"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "0.875rem",
                        borderWidth: 2,
                      }}
                    />
                  ) : (
                    <ArgonTypography variant="caption" color="error">
                      Follow-up Status not available
                    </ArgonTypography>
                  ))}
              </ArgonBox>

              {/* Onboarding Progress Bar */}
              <OnboardingProgressBar
                steps={onboardingSteps}
                key={JSON.stringify(onboardingSteps)}
              />

              <ArgonBox>
                <ApnaTabs tabsData={tabsData} />
              </ArgonBox>
            </ArgonBox>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddTutor;
